import * as yup from "yup";
import {
  MIN_BUDGET_VALUE,
  MAX_BUDGET_VALUE,
  BUDGET_SCHEDULE_REQUIRES_SCRIPT_BREAKDOWN_MESSAGE,
} from "./CreateProjectSheet.constants";
import { toFormattedCurrency } from "utils/currencyUtil";

// Form validation schema
export const createProjectSchema = yup.object().shape({
  name: yup
    .string()
    .required("Project Name is required")
    .max(165, "Project Name must be at most 165 characters long"),
  description: yup.string().max(512, "Description must be less than 512 characters").default(""),
  production_type: yup.string().required("Production type is required"),
  features: yup
    .object()
    .shape({
      has_budget: yup.boolean().default(true),
      max_budget: yup.number().when("has_budget", {
        is: true,
        then: (schema) =>
          schema
            .typeError("Max budget is required when budget feature is enabled")
            .required("Max budget is required when budget feature is enabled")
            .min(
              MIN_BUDGET_VALUE,
              `Budget must be at least ${toFormattedCurrency(MIN_BUDGET_VALUE)}`
            )
            .max(
              MAX_BUDGET_VALUE,
              `Budget must be at most ${toFormattedCurrency(MAX_BUDGET_VALUE)}`
            ),
        otherwise: (schema) => schema.optional(),
      }),
      has_coverage: yup.boolean().default(true),
      has_character_breakdown: yup.boolean().default(true),
      has_script_breakdown: yup.boolean().default(true),
      has_schedule: yup.boolean().default(true),
      schedule_start_date: yup.string().when("has_schedule", {
        is: true,
        then: (schema) =>
          schema.required("Schedule start date is required when schedule feature is enabled"),
        otherwise: (schema) => schema.optional(),
      }),
      production_state: yup.string().optional(),
      production_location: yup
        .object({
          name: yup.string().optional(),
          place_id: yup.string().nullable().optional(),
        })
        .optional(),
    })
    .test("budget-schedule-requires-script-breakdown", function (value) {
      if (!value) {
        return true;
      }
      if ((value.has_budget || value.has_schedule) && !value.has_script_breakdown) {
        return this.createError({
          path: `${this.path}.has_script_breakdown`,
          message: BUDGET_SCHEDULE_REQUIRES_SCRIPT_BREAKDOWN_MESSAGE,
        });
      }
      return true;
    }),
});
